//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACTION_UPDATE_URL } from '@/scripts/store/actions'
import { BING, GENERAL, GOOGLE, RAYBAN_STORES } from '@/scripts/constants/store-locator'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import {
  centerBingMapUsingLocation,
  centerBingMapUsingCoordinates,
  clearAllBingMapsMarkers,
  clearBingMapsEventHandlers,
  drawMarkersWithClusteringOnBingMap,
  initializeBingTooltip,
  triggerEventOnBingEntity,
} from '@/scripts/libs/bing-maps'
import {
  centerGoogleMapUsingCoordinates,
  centerGoogleMapUsingLocation,
  clearAllGoogleMapsMarkers,
  clearGoogleClustering,
  clearGoogleMapsEventListeners,
  drawMarkersOnGoogleMaps,
  initializeGoogleMarkerClustering,
  initializeGoogleTooltip,
  triggerEventOnGoogleEntity,
  setGoogleMapsZoom,
  registerOnZoomChangedEvent,
} from '@/scripts/libs/google-maps'
import { mapActions, mapGetters } from 'vuex'
import qs from 'qs'
import wcs from '@/scripts/libs/wcs'
import { EVENTS } from '@/scripts/constants/css-classes'
import {
  getTooltipContent,
  getSearchStoresUrl,
  loadExternalTranslations,
} from '@/scripts/libs/store-locator'
import { UPDATE_LABELS } from '@/scripts/store/labels'
import RbGoogleMaps from '@/elements/google-maps/google-maps.vue'
import RbGoogleAutocomplete from '@/elements/google-maps/google-autocomplete.vue'
import RbStoreLocatorFilters from '@/elements/store-locator/store-locator-filters.vue'
import RbStoreLocatorListItem from '@/elements/store-locator/store-locator-list-item.vue'
import RbStoreLocatorSidePanel from '@/elements/store-locator/store-locator-side-panel.vue'
import RbStoreLocatorStoreDetails from '@/elements/store-locator/store-locator-store-details.vue'
import RbStoreLocatorCountryDropdown from '@/elements/store-locator/store-locator-country-dropdown.vue'
import RbBingAutocomplete from '@/elements/bing-maps/bing-autocomplete.vue'
import RbBingMaps from '@/elements/bing-maps/bing-maps.vue'
import RbPanel from '@/elements/panel/rb-panel.vue'
import RbRadioAccordion from '@/elements/radio-accordion/rb-radio-accordion.vue'

import {
  TRACKER_HIDDEN_ACTION,
  TRACKER_CLICK,
  TRACKER_STORE_LOCATOR_SEARCH_RESULTS,
} from '@/scripts/constants/tracker'
import { STORE_LOCATOR_GEOLOCALIZED, STORE_LOCATOR_TEXT } from '@/scripts/constants/store-locator'
import { ZERO_PLACEHOLDER } from '@/scripts/constants/placeholders'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'
import { WcsPhysicalStores } from '@/scripts/libs/physical-stores/wcs/physical-stores'
import { DistributionChannel } from '@/scripts/libs/physical-stores/types/enums'

const { storeId, locale, storeLocator } = wcs.getStoreConfig()
const zoomLevel = 17

export default {
  name: 'rb-store-locator',
  components: {
    RbGoogleMaps,
    RbStoreLocatorFilters,
    RbStoreLocatorListItem,
    RbStoreLocatorSidePanel,
    RbStoreLocatorStoreDetails,
    RbStoreLocatorCountryDropdown,
    RbGoogleAutocomplete,
    RbBingAutocomplete,
    RbBingMaps,
    RbPanel,
    RbRadioAccordion,
  },
  props: {
    region: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      location: '',
      latitude: 0,
      longitude: 0,
      stores: undefined,
      googleMarkers: [],
      bingMarkers: [],
      commonMapTooltipInstance: undefined,
      activeFilters: [],
      googleMapReference: undefined,
      bingMapReference: undefined,
      isSidePanelActive: false,
      selectedStore: undefined,
      locale: '',
      bingEventsHandlers: [],
      prescriptionglasses: false,
      loading: false,
      googleClusteringInstances: {
        rayBanStores: undefined,
        otherStores: undefined,
      },
      resetLocation: { clear: false },
      sidepanelIsOpen: false,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    isChina() {
      return storeId === WcsStoreId.CHINA
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    isColumnVisible() {
      return !this.isMobile || (this.isMobile && !this.isSidePanelActive)
    },
    isCountryDropdownEnabled() {
      return (
        storeId === WcsStoreId.REST_OF_EUROPE ||
        (NoEcommerce.isStoreNoEcommerce() && !NoEcommerce.isTurkey())
      )
    },
    isInsourcing() {
      return this.region && this.language
    },
    mapProvider() {
      return this.isChina ? BING : GOOGLE
    },
    getStoreLocatorDescription() {
      if (this.isInsourcing) {
        if (this.prescriptionglasses) {
          return this.translation('store_locator.subtitlePrescription')
        } else {
          return this.translation('store_locator.subtitle')
        }
      }

      if (this.filterByLensCrafters && this.$te('store_locator.description')) {
        return this.$t('store_locator.description')
      }

      return storeLocator.description
    },
    filterByLensCrafters() {
      const filterByStore = WcsPhysicalStores.getStoresToFilterQueryParam()
      return filterByStore === DistributionChannel.LENS_CRAFTERS
    },
  },
  watch: {
    async googleMapReference() {
      if (this.prescriptionglasses) {
        await this.fetchStores(STORE_LOCATOR_TEXT, this.region)
        setGoogleMapsZoom(this.googleMapReference, 5)
      }
      if (!!this.latitude && !!this.longitude) {
        this.fetchStores()
      }
    },
  },
  created() {
    this.loadActiveFiltersFromUrl()
  },
  async mounted() {
    if (this.isInsourcing) {
      this.locale = `${this.language}-${this.region}`
      const externalTranslations = await loadExternalTranslations(this.language)
      this.$store.commit(`${UPDATE_LABELS}`, externalTranslations)
    } else {
      this.locale = locale
    }
  },
  beforeDestroy() {
    this.clearMapEventListenersAndHandlers()
  },
  methods: {
    ...mapActions({
      actionUpdateUrl: ACTION_UPDATE_URL,
    }),
    isStoreSelected(store) {
      if (this.selectedStore) {
        return store?.uniqueID === this.selectedStore?.uniqueID
      } else {
        return false
      }
    },
    setBingMapReference(value) {
      this.bingMapReference = value
    },
    setGoogleMapReference(value) {
      this.googleMapReference = value
    },
    searchNearbyStores(data) {
      if (!this.latitude && !this.longitude) {
        this.updatePlaceCoordinatesAndFetchStores(data, STORE_LOCATOR_GEOLOCALIZED)
      }
    },
    updatePlaceCoordinatesAndFetchStores(data, searchType = STORE_LOCATOR_TEXT) {
      this.location = data.value || data.requestAddress
      this.latitude = +data.latitude
      this.longitude = +data.longitude
      this.updateUrlWithSearchParameters()
      if (!!this.latitude && !!this.longitude) {
        this.fetchStores(searchType)
      }
    },
    updateUrlWithSearchParameters() {
      const localization = {
        location: this.location,
        latitude: this.latitude,
        longitude: this.longitude,
      }
      this.updateUrlWithParameters(localization)
    },
    async fetchStores(searchType = STORE_LOCATOR_TEXT, region = '') {
      this.loading = true
      /* TODO: Refactor Store Locator so it handles its own fullscreen loader */
      /* this.$store.commit(UPDATE_UI_STATE, {
        loading: true,
        fullLoadingText: this.translation('store_locator.loading_stores'),
      }) */

      if (this.googleMarkers.length > 0 || this.bingMarkers.length > 0) {
        this.clearMarkersFromMap()
      }
      const endpoint = this.isInsourcing
        ? getSearchStoresUrl(WcsStoreId.INSOURCING)
        : wcs.getEndPoint('storeLocator')

      const baseUrl = this.isInsourcing ? new URL(window.PUBLIC_PATH) : ''

      region = region ? region : this.getCountryCode()

      const physicalStores = await WcsPhysicalStores.fetchStoreLocatorPhysicalStores(
        endpoint,
        this.latitude,
        this.longitude,
        this.prescriptionglasses,
        this.activeFilters,
        region,
        baseUrl.origin
      )

      const sortedPhysicalStores =
        !!this.isInsourcing && this.prescriptionglasses
          ? WcsPhysicalStores.sortCityIndiaStoreLocator(physicalStores)
          : WcsPhysicalStores.mapAndSortPhysicalStores(physicalStores)

      this.stores = sortedPhysicalStores

      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_STORE_LOCATOR_SEARCH_RESULTS,
        value: {
          id: TRACKER_STORE_LOCATOR_SEARCH_RESULTS,
          Store_Search_Keyword: searchType === STORE_LOCATOR_TEXT ? this.location : '',
          Store_Search_Type: searchType,
          Store_Search_ResultItemsQnt: this.stores.length.toString(),
        },
      })
      this.initializeMapTooltip()
      this.updateMarkersAndCenterMap(baseUrl.origin)
      this.handleMapTooltip()
      this.loading = false
      /* TODO: Refactor Store Locator so it handles its own fullscreen loader */
      /* this.$store.commit(UPDATE_UI_STATE, { loading: false }) */
    },
    initializeMapTooltip() {
      if (this.isChina) {
        this.commonMapTooltipInstance = initializeBingTooltip(this.bingMapReference)
      } else {
        this.commonMapTooltipInstance = initializeGoogleTooltip()
      }
    },
    updateMarkersAndCenterMap(baseUrl = '') {
      if (this.isChina) {
        const rayBanStoresMarkers = drawMarkersWithClusteringOnBingMap(
          this.bingMapReference,
          this.stores.filter((store) => store.storeType === RAYBAN_STORES),
          RAYBAN_STORES
        )

        const otherStoresMarkers = drawMarkersWithClusteringOnBingMap(
          this.bingMapReference,
          this.stores.filter((store) => store.storeType !== RAYBAN_STORES),
          GENERAL
        )

        this.bingMarkers = [...rayBanStoresMarkers, ...otherStoresMarkers]

        centerBingMapUsingCoordinates(this.bingMapReference, this.latitude, this.longitude)
      } else {
        const rayBanStoresMarkers = drawMarkersOnGoogleMaps(
          {},
          this.stores.filter((store) => store.storeType === RAYBAN_STORES),
          this.googleMapReference,
          storeLocator?.zoomLevel
        )

        const otherStoresMarkers = drawMarkersOnGoogleMaps(
          {},
          this.stores.filter((store) => store.storeType !== RAYBAN_STORES),
          this.googleMapReference,
          storeLocator?.zoomLevel
        )

        this.googleMarkers = [...rayBanStoresMarkers, ...otherStoresMarkers]

        this.googleClusteringInstances.otherStores = initializeGoogleMarkerClustering(
          this.googleMapReference,
          this.commonMapTooltipInstance,
          otherStoresMarkers,
          GENERAL,
          baseUrl
        )

        this.googleClusteringInstances.rayBanStores = initializeGoogleMarkerClustering(
          this.googleMapReference,
          this.commonMapTooltipInstance,
          rayBanStoresMarkers,
          RAYBAN_STORES,
          baseUrl
        )

        registerOnZoomChangedEvent(this.googleMapReference, () => {
          this.commonMapTooltipInstance.close()
        })

        centerGoogleMapUsingCoordinates(this.googleMapReference, this.latitude, this.longitude)
      }
    },
    handleMapTooltip() {
      if (this.isChina) {
        this.handleBingTooltip()
      } else {
        this.handleGoogleTooltip()
      }
    },
    handleBingTooltip() {
      this.bingMarkers.map((marker) => {
        const handlerId = window.Microsoft.Maps.Events.addHandler(marker, EVENTS.CLICK, () => {
          this.selectedStore = this.getStoreFromSelectedMarker(marker)

          centerBingMapUsingLocation(this.bingMapReference, marker.getLocation())
          const tooltipContent = getTooltipContent(this.selectedStore, BING).replace(
            ZERO_PLACEHOLDER,
            this.translation('store_locator.list_item.get_direction')
          )

          this.commonMapTooltipInstance.setOptions({
            location: this.bingMapReference.getCenter(),
            visible: true,
            htmlContent: tooltipContent,
          })

          this.$refs[`store-${this.selectedStore.uniqueID}`][0].onSelectStoreFromMap()
        })
        this.bingEventsHandlers.push(handlerId)
      })
    },
    handleGoogleTooltip() {
      this.googleMarkers.map((marker) =>
        marker.addListener(EVENTS.CLICK, () => {
          this.selectedStore = this.getStoreFromSelectedMarker(marker)

          const tooltipContent = getTooltipContent(this.selectedStore, GOOGLE).replace(
            ZERO_PLACEHOLDER,
            this.translation('store_locator.list_item.get_direction')
          )
          this.commonMapTooltipInstance.setContent(tooltipContent)
          this.commonMapTooltipInstance.open(this.googleMapReference, marker)

          this.$refs[`store-${this.selectedStore.uniqueID}`][0].onSelectStoreFromMap()
        })
      )
    },
    toggleFilter(filterId) {
      if (this.activeFilters.includes(filterId)) {
        this.activeFilters = this.activeFilters.filter((filter) => filter !== filterId)
      } else {
        this.activeFilters.push(filterId)
      }

      const filters = {
        activeFilters: this.activeFilters,
        latitude: this.latitude,
        longitude: this.longitude,
        location: this.location,
      }
      this.updateUrlWithParameters(filters)

      if (!!this.latitude && !!this.longitude) {
        this.fetchStores()
      }
    },
    updateUrlWithParameters(parameters) {
      if (!!parameters.location && !!parameters.latitude && !!parameters.longitude) {
        this.actionUpdateUrl(parameters)
      } else {
        this.actionUpdateUrl({ location: undefined, latitude: undefined, longitude: undefined })
      }
    },
    loadActiveFiltersFromUrl() {
      const queryParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      })
      const activeFilters = queryParams['activeFilters'] ?? []
      this.activeFilters = Array.isArray(activeFilters) ? activeFilters : [activeFilters]
      this.location = queryParams['location'] ?? ''
      this.latitude = +queryParams['latitude'] ?? 0
      this.longitude = +queryParams['longitude'] ?? 0
      this.prescriptionglasses = queryParams['tags']?.includes('prescription')
    },
    openSidePanel() {
      if (this.isMobile) {
        this.sidepanelIsOpen = true
      }
      this.isSidePanelActive = true
    },
    closeSidePanel() {
      this.commonMapTooltipInstance?.close()
      setGoogleMapsZoom(this.googleMapReference, Number(storeLocator.zoomLevel))
      if (this.isMobile) {
        this.sidepanelIsOpen = false
      } else {
        const selectedStore = this.$refs[`store-${this.selectedStore?.uniqueID}`][0]
        selectedStore.$el.focus()
      }
      this.isSidePanelActive = false
    },
    getStoreFromSelectedMarker(clickedMarker) {
      return this.stores.find((store) => store.uniqueID === clickedMarker.uniqueID)
    },
    getMarkerInstanceOfSelectedStore() {
      if (this.isChina) {
        return this.bingMarkers.find((marker) => marker.uniqueID === this.selectedStore.uniqueID)
      } else {
        return this.googleMarkers.find((marker) => marker.uniqueID === this.selectedStore.uniqueID)
      }
    },
    showSelectedStoreOnMap(marker) {
      if (this.isChina) {
        centerBingMapUsingLocation(this.bingMapReference, marker.getLocation())
        triggerEventOnBingEntity(marker, EVENTS.CLICK)
      } else {
        centerGoogleMapUsingLocation(this.googleMapReference, marker.getPosition())
        setGoogleMapsZoom(this.googleMapReference, zoomLevel)
        triggerEventOnGoogleEntity(marker, EVENTS.CLICK)
      }
    },
    onSelectStoreFromList(selectedStoreId) {
      this.selectedStore = this.stores.find((store) => store.uniqueID === selectedStoreId)

      const selectedStoreMarker = this.getMarkerInstanceOfSelectedStore()
      this.showSelectedStoreOnMap(selectedStoreMarker)

      this.openSidePanel()
    },
    onCountrySelectionChange(locale) {
      this.latitude = 0
      this.longitude = 0
      this.location = undefined
      this.stores = []
      this.clearMarkersFromMap()
      this.updateUrlWithSearchParameters()
      this.resetLocation = {
        clear: true,
      }
      this.locale = locale
    },
    onSearchIconClick() {
      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_CLICK,
        value: {
          data_element_id: 'X_X_Store_Search',
        },
      })
    },
    clearMarkersFromMap() {
      if (this.isChina) {
        clearAllBingMapsMarkers(this.bingMarkers, this.bingMapReference)
      } else {
        clearAllGoogleMapsMarkers(this.googleMarkers)
        clearGoogleClustering(this.googleClusteringInstances.rayBanStores)
        clearGoogleClustering(this.googleClusteringInstances.otherStores)
      }
    },
    clearMapEventListenersAndHandlers() {
      if (this.isChina) {
        clearBingMapsEventHandlers(this.bingMapReference, this.bingEventsHandlers)
      } else {
        clearGoogleMapsEventListeners(this.googleMapReference)
      }
    },
    getCountryCode() {
      return WcsLocales.mapCountryCode(locale)
    },
  },
}
